if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');

        const variantInput =
          this.form.querySelector('[name=id]');

        if (variantInput) {
          variantInput.disabled = false;
        }

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        this.cart =
          document.querySelector(
            'cart-notification'
          ) ||
          document.querySelector(
            'cart-drawer'
          );

        this.submitButton =
          this.querySelector(
            '[type="submit"]'
          );

        if (
          document.querySelector(
            'cart-drawer'
          )
        ) {
          this.submitButton?.setAttribute(
            'aria-haspopup',
            'dialog'
          );
        }
      }

      async onSubmitHandler(event) {
        event.preventDefault();

        if (
          this.submitButton?.getAttribute(
            'aria-disabled'
          ) === 'true'
        ) {
          return;
        }

        this.handleErrorMessage();
        this.setLoading(true);

        try {
          const parentVariantId =
            this.getParentVariantId();

          if (!parentVariantId) {
            throw new Error(
              '商品バリエーションを取得できませんでした。'
            );
          }

          const quantity =
            this.getQuantity();

          const selectedAddons =
            this.getSelectedAddons();

          const configId =
            this.createConfigId();

          const summary =
            this.getOptionSummary();

          const items = [
            {
              id: parentVariantId,
              quantity,
              properties: {
                ...(summary
                  ? {
                      '追加オプション':
                        summary
                    }
                  : {}),
                _pika_config_id:
                  configId,
                _pika_item_type:
                  'parent'
              }
            }
          ];

          selectedAddons.forEach(
            (addon) => {
              items.push({
                id: Number(
                  addon.variantId
                ),
                quantity,
                properties: {
                  _pika_option_label:
                    `${addon.groupLabel}：${addon.label}`,
                  _pika_config_id:
                    configId,
                  _pika_item_type:
                    'addon',
                  _pika_parent_variant_id:
                    String(parentVariantId)
                }
              });
            }
          );

          const response =
            await fetch(
              window.routes
                .cart_add_url,
              {
                method: 'POST',
                headers: {
                  'Content-Type':
                    'application/json',
                  Accept:
                    'application/json',
                  'X-Requested-With':
                    'XMLHttpRequest'
                },
                body: JSON.stringify({
                  items,
                  sections:
                    this.cart
                      ? this.cart
                          .getSectionsToRender()
                          .map(
                            (section) =>
                              section.id
                          )
                      : [],
                  sections_url:
                    window.location.pathname
                })
              }
            );

          const result =
            await response.json();

          if (!response.ok) {
            throw new Error(
              result.description ||
                result.message ||
                'カートへの追加に失敗しました。'
            );
          }

          this.error = false;

          if (!this.cart) {
            window.location =
              window.routes.cart_url;

            return;
          }

          const quickAddModal =
            this.closest(
              'quick-add-modal'
            );

          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                window.setTimeout(
                  () => {
                    this.cart.renderContents(
                      result
                    );
                  }
                );
              },
              {
                once: true
              }
            );

            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(
              result
            );
          }
        } catch (error) {
          console.error(error);

          this.error = true;

          this.handleErrorMessage(
            error.message
          );
        } finally {
          this.setLoading(false);
        }
      }

      getParentVariantId() {
        return Number(
          this.form.querySelector(
            '[name="id"]'
          )?.value || 0
        );
      }

      getQuantity() {
        const quantity = Number(
          this.form.querySelector(
            '[name="quantity"]'
          )?.value || 1
        );

        if (
          !Number.isFinite(quantity) ||
          quantity < 1
        ) {
          return 1;
        }

        return quantity;
      }

      getOptionsRoot() {
        const formId =
          this.form.id;

        return (
          document.querySelector(
            `[data-pika-product-options][data-product-form-id="${formId}"]`
          ) ||
          document.querySelector(
            '[data-pika-product-options]'
          )
        );
      }

      getSelectedAddons() {
        const root =
          this.getOptionsRoot();

        if (!root) {
          return [];
        }

        try {
          const addons =
            JSON.parse(
              root.dataset
                .selectedAddons ||
                '[]'
            );

          return addons.filter(
            (addon) => {
              return (
                Number(
                  addon.variantId
                ) > 0
              );
            }
          );
        } catch (error) {
          console.error(
            'PIKA: 追加オプション情報を解析できませんでした。',
            error
          );

          return [];
        }
      }

      getOptionSummary() {
        const root =
          this.getOptionsRoot();

        if (!root) {
          return '';
        }

        const input =
          root.querySelector(
            '[data-pika-option-summary-input]'
          );

        return input?.value || '';
      }

      createConfigId() {
        if (
          window.crypto &&
          typeof window.crypto
            .randomUUID ===
            'function'
        ) {
          return window.crypto.randomUUID();
        }

        return [
          Date.now(),
          Math.random()
            .toString(36)
            .slice(2)
        ].join('-');
      }

      setLoading(isLoading) {
        if (!this.submitButton) {
          return;
        }

        const spinner =
          this.querySelector(
            '.loading-overlay__spinner'
          );

        if (isLoading) {
          this.submitButton.setAttribute(
            'aria-disabled',
            'true'
          );

          this.submitButton.classList.add(
            'loading'
          );

          spinner?.classList.remove(
            'hidden'
          );

          return;
        }

        this.submitButton.classList.remove(
          'loading'
        );

        spinner?.classList.add(
          'hidden'
        );

        if (!this.error) {
          this.submitButton.removeAttribute(
            'aria-disabled'
          );
        }
      }

      handleErrorMessage(
        errorMessage = false
      ) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (
          !this.errorMessageWrapper
        ) {
          if (errorMessage) {
            alert(errorMessage);
          }

          return;
        }

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (
          errorMessage &&
          this.errorMessage
        ) {
          this.errorMessage.textContent =
            errorMessage;
        }
      }
    }
  );
}